<template>
  <div class="search-box">
    <el-form ref="searchFormRef" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="机构id" prop="storeId">
        <el-input v-model="formInline.storeId" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="机构名称" prop="storeName">
        <el-input v-model="formInline.storeName" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="地址" prop="storeAddress">
        <el-input v-model="formInline.storeAddress" clearable placeholder="请输入" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="onReset(searchFormRef)">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-box">
    <div class="table-btns">
      <el-tooltip class="box-item" effect="dark" content="删除现有门店信息，同步相关体检机构最新门店信息" placement="top-start">
        <el-button type="warning" :icon="InfoFilled" @click="syncShopListBtn">同步门店信息</el-button>
      </el-tooltip>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column type="index" label="序号" align="center" width="90" />
      <el-table-column prop="storeId" label="机构id" align="center" />
      <el-table-column prop="storeName" label="机构名称" align="center" />
      <el-table-column prop="storePhone" label="电话" align="center" />
      <el-table-column prop="openingHours" label="体检接待时间" align="center" />
      <el-table-column prop="storeAddress" label="地址" align="center" />
      <el-table-column prop="countyName" label="区县" align="center" />
      <el-table-column prop="cityName" label="城市" align="center" />
      <el-table-column prop="provinceName" label="机构所在省份" align="center" />
      <el-table-column prop="latitude" label="维度（百度坐标系）" align="center" />
      <el-table-column prop="longitude" label="经度（百度坐标系）" align="center" />
      <el-table-column prop="brandName" label="品牌标志" align="center" />
      <el-table-column prop="extend1" label="备注1" align="center" />
      <el-table-column prop="extend2" label="备注2" align="center" />
      <el-table-column prop="score" label="门店评分" align="center" />
      <el-table-column prop="address" label="操作" align="center" width="180">
        <template #default="scope">
          <el-button type="primary" size="small" @click="editFn(scope.row)">修改</el-button>
          <el-button type="danger" size="small" @click="delFn(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" v-model:current-page="currentPage" v-model:page-size="pageSize"
      :page-sizes="[10, 50, 100, 200]" :small="small" :background="background"
      layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
  </div>
  <el-dialog v-model="dialogFormVisible" append-to-body :close-on-click-modal="false" title="修改门店评分" width="500">
    <el-form :model="form" label-width="100px">
      <el-form-item label="门店评分">
        <el-input v-model="form.score" placeholder="请输入评分" type="number"><template #append>（1~100分之间）</template></el-input>
      </el-form-item>
      <el-form-item label="备注1">
        <el-input v-model="form.extend1" placeholder="请输入备注"></el-input>
      </el-form-item>
      <el-form-item label="备注2">
        <el-input v-model="form.extend2" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="comboInfoConfirm">
          确定
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref, onMounted, nextTick } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { InfoFilled } from "@element-plus/icons-vue";
import service from "@/http/request.js";
const tableData = ref();

const formInline = reactive({
  storeId: null,
  storeName: null,
  storeAddress: null,
});
const searchFormRef = ref();
const onSubmit = () => {
  _shopList();
};
const onReset = (formEl) => {
  formEl.resetFields();
  pageSize.value = 10;
  currentPage.value = 1;
  _shopList();
};
const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);
const handleSizeChange = (val) => {
  pageSize.value = val;
  _shopList();
};
const handleCurrentChange = (val) => {
  currentPage.value = val;
  _shopList();
};
const _shopList = () => {
  console.log(formInline.openingHours);

  service.post('/health/web/healthOrg/page', {
    pageSize: pageSize.value,
    pageNo: currentPage.value,
    ...formInline
  })
    .then(data => {
      if (data.data.code == 200) {
        tableData.value = data.data.data.records
        total.value = data.data.data.total
      }
    })
    .catch(err => {
      ElMessage({
        message: err.message,
        type: "error",
      });
    })
};
const syncShopListBtn = () => {
  ElMessageBox.confirm("请确认是否同步相关体检机构最新门店信息？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
    closeOnClickModal: false,
  }).then(() => {
    service.get('/health/rich/aws/syncHealthOrg')
      .then(data => {
        if (data.data.code == 200) {
          ElMessage({
            message: "同步成功，已加载所有门店",
            type: "success",
          });
          _shopList();
        }
      })
      .catch(err => {
        ElMessage({
          message: err.message,
          type: "error",
        });
      })
  })
}

const delFn = (row) => {
  ElMessageBox.confirm(`请确认是否删除 ${row.storeName} 门店？`, "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
    closeOnClickModal: false,
  }).then(() => {
    service.delete('/health/web/healthOrg/delete/' + row.id)
      .then(data => {
        console.log(data)
        if (data.data.code == 200) {
          ElMessage({
            message: "删除成功",
            type: "success",
          });
          _comboList();
        }
      })
      .catch(err => {
        ElMessage({
          message: err.message,
          type: "error",
        });
      })
  })
}

let dialogFormVisible = ref(false)
const form = reactive({
  score: "",
  extend1: "",
  extend2: "",
});
const editFn = (row) => {
  form.storeId = row.storeId
  form.score = row.score
  form.extend1 = row.extend1
  form.extend2 = row.extend2

  dialogFormVisible.value = true
}
const comboInfoConfirm = () => {
  service.post('/health/web/healthOrg/update', {
    ...form
  })
    .then(data => {
      console.log(data)
      if (data.data.code == 200) {
        ElMessage({
          message: "修改成功",
          type: "success",
        });
        dialogFormVisible.value = false;
        _shopList();
      }
    })
    .catch(err => {
      ElMessage({
        message: err.message,
        type: "error",
      });
    })
}

onMounted(() => {
  _shopList();
});
</script>
<style scoped lang="scss">
.success {
  color: #02bc6c;
}

.red {
  color: #da0f0f;
}
</style>
